/**
 * Extracts the host (hostname and port, if present) from a given string, which can be a full URL or a host.
 *
 * @param {string} input - The string from which to extract the host (can be a URL or a host).
 * @returns {string} The host (hostname and port, if present) extracted from the input, or an empty string if invalid.
 */
export function getHostFromUrl(input: string): string {
  try {
    const { host } = new URL(input);
    return host;
  } catch {
    const hostPattern = /^(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+(:[0-9]+)?$/;
    if (hostPattern.test(input)) {
      return input;
    }
    return "";
  }
}
